import Vue from 'vue';
import Vuex from 'vuex';
import { enumLanguage } from '@/constants/index.js';
// import { useSocket } from "@/utils/useSocket.js";

Vue.use(Vuex);

// 获取 Socket Token 的辅助函数
// function fetchSocketToken(axios) {
//     return axios({
//         method: "GET",
//         url: "/apis/evaluation/generate/socket/token/",
//     });
// }

function storeLocalStore(state, key) {
  //    window.localStorage.setItem("userMsg",JSON.stringify(state));
  var message = JSON.parse(window.localStorage.getItem('userMsg'));
  if (message) {
    message[key] = state[key];
    window.localStorage.setItem('userMsg', JSON.stringify(message));
  } else {
    window.localStorage.setItem('userMsg', JSON.stringify(state));
  }
}

export default new Vuex.Store({
  state: {
    username: '',
    userid: '',
    schedulename: '',
    scheduleid: 0,
    arrangementid: 0,
    entryid: 0,
    interviewerGroupId: 0,
    oid: '',
    entriesNumberAndId: [],
    entryKeys: [], // 存储接口返回的keys数组（字段定义）
    entryList: [], // 存储/entries/接口返回的完整list（含所有字段值）
    isLogin: false,
    isMaster: false,
    isVideo: false,
    startTime: [], //面试开始时间
    endTime: [], //面试结束时间
    bjTime: '',
    videoSource: '', //设备检测里选中的摄像头
    audioSource: '', //设备检测里选中的麦克风
    interviewerStatus: [],
    isMobile: null, //是否是移动端
    arrangementSign: false, // 是否需要显示重新签字提示
    //面试段的面试者信息
    interviewerMessage: {},
    // 视频面试信息
    videoInterviewInfo: {},
    // 多语言
    systemLanguage: enumLanguage['中文简体'], // 默认简体中文
    arrangementIsSigned: false, // 是否已经签字
    visibleName: false, // 是否显示考生姓名
    // Socket 全局管理
    // socketInstance: null, // socket 管理实例
    // socketToken: null, // 认证 token
    // isSocketConnected: false, // 连接状态
  },
  mutations: {
    storeUsername(state, name) {
      state.username = name;
      storeLocalStore(state, 'username');
    },
    storeUserid(state, id) {
      state.userid = id;
      storeLocalStore(state, 'userid');
    },
    storeOid(state, oid) {
      state.oid = oid;
      storeLocalStore(state, 'oid');
    },
    storeSchedulename(state, name) {
      state.schedulename = name;
      storeLocalStore(state, 'schedulename');
    },
    storeScheduleid(state, id) {
      state.scheduleid = Number(id);
      storeLocalStore(state, 'scheduleid');
    },
    storeArrangementid(state, id) {
      state.arrangementid = Number(id);
      storeLocalStore(state, 'arrangementid');
    },
    storeEntryid(state, id) {
      state.entryid = Number(id);
      storeLocalStore(state, 'entryid');
    },
    storeEntriesNumberAndId(state, arr) {
      state.entriesNumberAndId = arr;
      storeLocalStore(state, 'entriesNumberAndId');
    },
    storeEntryKeys(state, keys) {
      state.entryKeys = keys;
      storeLocalStore(state, 'entryKeys');
    },
    storeEntryList(state, list) {
      state.entryList = list;
      storeLocalStore(state, 'entryList');
    },
    storeLoginState(state, flag) {
      state.isLogin = flag;
      storeLocalStore(state, 'isLogin');
    },
    storeInterviewerGroupId(state, id) {
      state.interviewerGroupId = Number(id);
      storeLocalStore(state, 'interviewerGroupId');
    },
    storeIsMaster(state, flag) {
      // 判断是不是面试官组长
      state.isMaster = flag;
      storeLocalStore(state, 'isMaster');
    },
    storeIsVideo(state, flag) {
      // 判断是不是视频面试
      state.isVideo = flag;
      storeLocalStore(state, 'isVideo');
    },
    storeBJTime(state, time) {
      // 存储北京时间
      state.bjTime = time;
      storeLocalStore(state, 'bjTime');
    },
    storeInterviewerStatus(state, data) {
      state.interviewerStatus = data;
      storeLocalStore(state, 'interviewerStatus');
    },
    storeStartTime(state, time) {
      state.startTime = time;
      storeLocalStore(state, 'startTime');
    },
    storeEndTime(state, time) {
      state.endTime = time;
      storeLocalStore(state, 'endTime');
    },
    storeVideoSource(state, source) {
      state.videoSource = source;
      storeLocalStore(state, 'videoSource');
    },
    storeAudioSource(state, source) {
      state.audioSource = source;
      storeLocalStore(state, 'audioSource');
    },
    storeInterviewerMessage(state, message) {
      state.interviewerMessage = message;
      storeLocalStore(state, 'interviewerMessage');
    },
    storeVideoInterviewInfo(state, data) {
      state.videoInterviewInfo = data;
      storeLocalStore(state, 'videoInterviewInfo');
    },
    storeArrangementSign(state, flag) {
      state.arrangementSign = flag;
      storeLocalStore(state, 'arrangementSign');
    },
    storeIsMobile(state, flag) {
      state.isMobile = flag;
      storeLocalStore(state, 'isMobile');
    },
    storeSystemLanguage(state, language) {
      state.systemLanguage = language;
      storeLocalStore(state, 'systemLanguage');
    },
    // 面试官是否已经签字
    storeArrangementIsSigned(state, flag) {
      state.arrangementIsSigned = flag;
      storeLocalStore(state, 'arrangementIsSigned');
    },
    // 是否显示考生姓名
    storeVisibleName(state, flag) {
      state.visibleName = flag;
      storeLocalStore(state, 'visibleName');
    },
    // Socket 全局管理
    // setSocketInstance(state, instance) {
    //     state.socketInstance = instance;
    // },
    // setSocketToken(state, token) {
    //     state.socketToken = token;
    // },
    // setSocketConnected(state, flag) {
    //     state.isSocketConnected = flag;
    // },
  },
  actions: {
    /**
     * 初始化全局 Socket 连接
     * @param {Object} context - Vuex context
     * @param {Object} options - 配置选项
     * @param {Function} options.axios - axios 实例（组件中的 this._axios）
     * @param {Object} options.groupMessageCallbacks - 群组消息回调
     */
    // async initSocket({ commit, state }, { axios, groupMessageCallbacks } = {}) {
    //     // 避免重复初始化 - 单例模式
    //     if (state.socketInstance) {
    //         if (state.isSocketConnected) {
    //             console.log("Socket already connected, reusing existing connection");
    //             return state.socketInstance;
    //         }
    //         // 复用现有实例，只是重新连接
    //         console.log("Socket instance exists but disconnected, reconnecting...");
    //         state.socketInstance.connect();
    //         commit("setSocketConnected", true);
    //         return state.socketInstance;
    //     }
    //
    //     try {
    //         // 获取 Socket Token
    //         const response = await fetchSocketToken(axios);
    //         const token = response.data?.data?.token;
    //
    //         if (!token) {
    //             console.error("Failed to get socket token");
    //             return null;
    //         }
    //
    //         commit("setSocketToken", token);
    //         console.log("Socket token obtained:", token);
    //
    //         // 初始化 socket 实例
    //         const socketInstance = useSocket({
    //             token,
    //             autoConnect: false,
    //             groupMessageCallbacks,
    //         });
    //
    //         // 手动初始化并连接
    //         socketInstance.init();
    //         socketInstance.connect();
    //
    //         commit("setSocketInstance", socketInstance);
    //         commit("setSocketConnected", true);
    //
    //         // 监听连接状态变化
    //         if (socketInstance.socket) {
    //             socketInstance.socket.on("disconnect", () => {
    //                 commit("setSocketConnected", false);
    //             });
    //             socketInstance.socket.on("connect", () => {
    //                 commit("setSocketConnected", true);
    //             });
    //         }
    //
    //         return socketInstance;
    //     } catch (error) {
    //         console.error("Failed to initialize socket:", error);
    //         return null;
    //     }
    // },
    /**
     * 销毁全局 Socket 连接
     */
    // destroySocket({ commit, state }) {
    //     if (state.socketInstance) {
    //         state.socketInstance.destroy();
    //         commit("setSocketInstance", null);
    //         commit("setSocketToken", null);
    //         commit("setSocketConnected", false);
    //         console.log("Socket connection destroyed");
    //     }
    // },
  },
});
